import React from 'react';
import moment from 'moment';
import { useTheme } from '@emotion/react';
import { Box, Chip, Tooltip, Typography } from '@mui/material';

const BOUNCE_LABELS = {
    bounce: "Bounced",
    complaint: "Spam complaint",
    rejected: "Rejected",
};

// Email column cell: the address, plus a red flag when mail to it bounced.
// Clicking the flag opens the update-email popup.
const EmailBounceCell = ({ email, bounce, onUpdate }) => {
    const theme = useTheme();
    if (!email) return <>-</>;

    return (
        <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
            <Typography sx={{ fontSize: "0.875rem", wordBreak: "break-all", color: bounce ? theme.palette.customColors.r400 : "inherit" }}>
                {email}
            </Typography>
            {bounce && (
                <Tooltip
                    title={
                        <span>
                            {bounce?.reason || "Emails to this address are not being delivered."}
                            {bounce?.last_bounced_at && <><br />Last bounced {moment(bounce.last_bounced_at).format("DD-MMM-YYYY HH:mm")}</>}
                            <br />Click to update the email.
                        </span>
                    }
                >
                    <Chip
                        size="small"
                        label={BOUNCE_LABELS[bounce?.type] || "Bounced"}
                        onClick={onUpdate}
                        sx={{
                            borderRadius: "4px",
                            fontWeight: 600,
                            color: theme.palette.customColors.r500,
                            backgroundColor: theme.palette.customColors.r50,
                            border: `1px solid ${theme.palette.customColors.r75}`,
                        }}
                    />
                </Tooltip>
            )}
        </Box>
    );
};

export default EmailBounceCell;
